import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FileNamePipe } from '../../pipes/file-name.pipe';
import { HyphenPipe } from '../../pipes/hyphen.pipe';
import { DateUtil } from '../../utils/date.util';
import { MenuItemToKeyValuePipe } from '../../pipes/menu-item-to-key-value.pipe';
import { AvatarComponent } from './avatar/avatar.component';
import { PaginationComponent } from './pagination/pagination.component';
import { StatusIconComponent } from './status-icon/status-icon.component';
import { TextInputComponent } from './forms/text-input/text-input.component';
import { SelectInputComponent } from './forms/select-input/select-input.component';
import { CheckboxListComponent } from './forms/checkbox-list/checkbox-list.component';
import { CheckboxInputComponent } from './forms/checkbox-input/checkbox-input.component';
import { ModalComponent } from './modal/modal.component';
import { SwitchInputComponent } from './forms/switch-input/switch-input.component';
import { PowerBiComponent } from './power-bi/power-bi.component';
import { NotificationComponent } from './notification/notification.component';
import { AccordionComponent } from './accordion/accordion.component';
import { RichTextDirective } from '../../directives/rich-text.directive';
import { IfIeDirective } from '../../directives/if-ie.directive';
import { DocumentationComponent } from './documentation/documentation.component';
import { NotificationDetailComponent } from './notification-detail/notification-detail.component';
import { LoaderComponent } from './loader/loader.component';
import { PortalsComponent } from './portals/portals.component';
import { AdministratorsComponent } from './administrators/administrators.component';
import { AccountComponent } from './account/account.component';
import { SearchComponent } from './search/search.component';
import { SafePipe } from '../../pipes/safe.pipe';
import { DropdownItemPipe } from '../../pipes/dropdown-item.pipe';
import { FileSizePipe } from '../../pipes/file-size.pipe';
import { CollapsibleComponent } from './collapsible/collapsible.component';
import { AccountManagerComponent } from './account-manager/account-manager.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { InputErrorComponent } from './forms/input-error/input-error.component';
import { CardComponent } from './card/card.component';
import { SelectOptionsPipe } from '../../pipes/select-options.pipe';
import { PortalsService } from '../../services/portals.service';
import { SearchService } from '../../services/search.service';
import { NoticeComponent } from './notice/notice.component';

@NgModule({
    imports: [CommonModule, RouterModule, ReactiveFormsModule],
    declarations: [
        RichTextDirective,
        IfIeDirective,
        SafePipe,
        HyphenPipe,
        FileNamePipe,
        FileSizePipe,
        DropdownItemPipe,
        SelectOptionsPipe,
        MenuItemToKeyValuePipe,
        AvatarComponent,
        PaginationComponent,
        StatusIconComponent,
        LoaderComponent,
        TextInputComponent,
        SelectInputComponent,
        CheckboxListComponent,
        CheckboxInputComponent,
        ModalComponent,
        SwitchInputComponent,
        PowerBiComponent,
        PortalsComponent,
        NotificationComponent,
        AccordionComponent,
        DocumentationComponent,
        NotificationDetailComponent,
        AdministratorsComponent,
        AccountComponent,
        SearchComponent,
        CollapsibleComponent,
        AccountManagerComponent,
        SubscribeComponent,
        InputErrorComponent,
        CardComponent,
        NoticeComponent,
    ],
    exports: [
        RichTextDirective,
        SafePipe,
        HyphenPipe,
        FileNamePipe,
        FileSizePipe,
        DropdownItemPipe,
        SelectOptionsPipe,
        MenuItemToKeyValuePipe,
        AvatarComponent,
        PaginationComponent,
        PowerBiComponent,
        PortalsComponent,
        StatusIconComponent,
        LoaderComponent,
        TextInputComponent,
        SelectInputComponent,
        CheckboxListComponent,
        CheckboxInputComponent,
        SwitchInputComponent,
        NotificationComponent,
        AccordionComponent,
        DocumentationComponent,
        AdministratorsComponent,
        AccountComponent,
        SearchComponent,
        AccountManagerComponent,
        SubscribeComponent,
        IfIeDirective,
        InputErrorComponent,
        CardComponent,
        CollapsibleComponent,
        NoticeComponent,
    ],
    providers: [PortalsService, SearchService, DateUtil],
})
export class SharedModule { }
